module.exports = __webpack_public_path__ + "img/horizontal_7_7_7005.86d78003.png";